import { Page } from "@/models/page-models/Page";

export const ComplaintEdit: Page = {
  "path": "complaint/:complaintId",
  "name": "Complaint",
  "props": {
    "data": {
      "title": "Complaint",
      "printable": "FALSE",
      "url": "complaint/:complaintId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.complaint.data._id",
                  "label": "Doc ID#",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "fetchedData.complaint.data.createdAt",
                  "label": "Creation Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{fetchedData.complaint.data.createdAt}},show-time)",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "fetchedData.complaint.data.updatedAt",
                  "label": "Last Updated",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{fetchedData.complaint.data.updatedAt}},show-time)",
                  "printable": false
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.complaint.data.createdBy.displayName",
                  "label": "Created By",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "fetchedData.complaint.data.status",
                  "label": "Status",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "fetchedData.complaint.data.rejectionReason",
                  "label": "Failure Reason",
                  "showIf": "{{fetchedData.complaint.data.rejectionReason}}",
                  "printable": false
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.complaintType",
                  "label": "Type of Complaint",
                  "disabled": "fn(MATCH_DEPARTMENT,QA)",
                  "items": "[\"Full Rejection\",\"Partial Rejection\",\"Awareness\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.customer",
                  "label": "Select Customer",
                  "disabled": "TRUE",
                  "items": "fetchedData.customers",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                }
              ]
            },
            {
              "name": "4a",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.invoice",
                  "label": "Select Invoice",
                  "disabled": "TRUE",
                  "items": "fetchedData.invoicesArray",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,invoiceDescription,{{__item}})"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.defectiveOrder",
                  "label": "Select Order",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedOrder",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedOrder"
                      },
                      "name": "copySelectedOrder"
                    }
                  ],
                  "disabled": "fn(MATCH_DEPARTMENT,QA)",
                  "showIf": "{{formData.invoice}}",
                  "items": "fetchedData.invOrders",
                  "itemText": "id.product.alias",
                  "itemValue": "id._id",
                  "formula": "fn(CONCAT,{{__item.id.product._id}}, ,fn(HELPER_FN,productAlias,{{__item.id.product}}))"
                },
                {
                  "type": "label",
                  "variable": "formData.defectiveOrder",
                  "label": "Order Link",
                  "url": "/order/{{formData.defectiveOrder}}",
                  "showIf": "{{formData.defectiveOrder}}",
                  "printable": false
                }
              ],
              "showIf": "fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}})"
            },
            {
              "name": "4b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.invoice",
                  "label": "select Invoice",
                  "disabled": "TRUE",
                  "items": "fetchedData.invoicesArray",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,invoiceDescription,{{__item}})"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.defectiveCalloff",
                  "label": "Select Order(Calloff)",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedOrder",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedOrder"
                      },
                      "name": "copySelectedOrder"
                    }
                  ],
                  "disabled": "fn(MATCH_DEPARTMENT,QA)",
                  "showIf": "{{fetchedData.invoiceDetails}}",
                  "items": "fetchedData.invoiceDetails.data.callOffs",
                  "itemText": "callOff.product.alias",
                  "itemValue": "callOff._id",
                  "formula": "fn(CONCAT,{{__item.callOff.product._id}}, ,fn(HELPER_FN,productAlias,{{__item.callOff.product}}))"
                },
                {
                  "type": "label",
                  "variable": "fetchedData.selectedOrder.orders.0.order",
                  "label": "Order Link",
                  "url": "/order/{{fetchedData.selectedOrder.orders.0.order}}",
                  "showIf": "{{fetchedData.selectedOrder.orders.0.order}}",
                  "printable": false
                }
              ],
              "showIf": "fn(NOT,fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}}))"
            },
            {
              "name": "5a",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Order Quantity",
                  "showIf": "{{formData.defectiveOrder}}",
                  "labelType": "formula",
                  "formula": "fn(CONCAT,fn(HELPER_FN,kgToSellingUnitQuantity,{{fetchedData.selectedOrder.id}},{{fetchedData.selectedOrder.fg}},{{fetchedData.selectedOrder.quantity}}), ,{{fetchedData.selectedOrder.id.unit.unit2}},(s))"
                },
                {
                  "type": "input",
                  "variable": "formData.defectiveQuantity",
                  "label": "Estimated Defective Order Quantity",
                  "unit": "{{fetchedData.selectedOrder.id.unit.unit2}}",
                  "disabled": "fn(MATCH_DEPARTMENT,QA)",
                  "showIf": "{{formData.defectiveOrder}}"
                },
                {
                  "type": "label",
                  "label": "Estimated Value",
                  "showIf": "{{formData.defectiveOrder}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,{{{{fetchedData.selectedOrder.id.unitPrice}}*{{formData.defectiveQuantity}}}})"
                }
              ],
              "showIf": "fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}})"
            },
            {
              "name": "5b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Order quantity",
                  "showIf": "{{formData.defectiveCalloff}}",
                  "labelType": "formula",
                  "formula": "fn(CONCAT,{{fetchedData.selectedOrder.quantity}}, ,{{fetchedData.selectedOrder.callOff.unit.unit2}},(s))"
                },
                {
                  "type": "input",
                  "variable": "formData.defectiveQuantity",
                  "label": "Estimated Defective Order Quantity",
                  "unit": "{{fetchedData.selectedOrder.callOff.unit.unit2}}",
                  "disabled": "fn(MATCH_DEPARTMENT,QA)",
                  "showIf": "{{formData.defectiveCalloff}}"
                },
                {
                  "type": "label",
                  "label": "Estimated Value",
                  "showIf": "{{formData.defectiveCalloff}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,{{{{fetchedData.selectedOrder.callOff.unitPrice}}*{{formData.defectiveQuantity}}}})"
                }
              ],
              "showIf": "fn(NOT,fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}}))"
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.description",
                  "label": "Description",
                  "disabled": "fn(MATCH_DEPARTMENT,QA)",
                  "showIf": "{{formData.invoice}}"
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "formData.pictures",
                  "label": "Add Pictures",
                  "disabled": "FALSE",
                  "showIf": "{{formData.invoice}}",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "picture",
                          "label": "Picture",
                          "disabled": "FALSE",
                          "color": "primary",
                          "previewType": "standard"
                        }
                      ]
                    }
                  ]
                }
              ],
              "disabled": "fn(MATCH_DEPARTMENT,QA)"
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "formData.investigation.fiveWhys",
                  "label": "Why did this Happen?",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "input",
                          "variable": "fiveWhys",
                          "label": "Reason",
                          "disabled": "FALSE"
                        }
                      ]
                    }
                  ],
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),!=,'Pending')"
                }
              ],
              "disabled": "fn(MATCH_ROLE,Sales | Manager)",
              "showIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.investigation.rootCause",
                  "label": "Root Cause",
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))",
                  "inputType": "longText"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),!=,'Pending')",
              "disabled": "fn(MATCH_ROLE,Sales | Manager)"
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.investigation.actionPlan",
                  "label": "Action Plan",
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))",
                  "inputType": "longText"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),!=,'Pending')",
              "disabled": "fn(MATCH_ROLE,Sales | Manager)"
            },
            {
              "name": "10",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.investigation.personInCharge",
                  "label": "Owner",
                  "showIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),!=,'Pending')",
              "disabled": "fn(MATCH_ROLE,Sales | Manager)"
            },
            {
              "name": "11",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.managementDecision",
                  "label": "Management Decision",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),!=,'Pending')",
              "disabled": "fn(NOT,fn(MATCH_ROLE,General Manager))"
            },
            {
              "name": "12",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                      "name": "updateComplaint",
                      "type": "fnSubmit",
                      "arg1Key": "apiUrl",
                      "arg1Value": "/api/v1/customer-complaint/{{__params.complaintId}}/update",
                      "arg2Key": "postData",
                      "arg2Value": "formData",
                      "arg3Key": "refreshPage",
                      "arg3Value": "TRUE",
                      "arg4Key": "requestMethod",
                      "arg4Value": "PATCH"
                    },
                      "name": "updateComplaint"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))",
                  "color": "primary"
                }
              ]
            }
          ],
          "disabled": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),==,'Rejected'),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),==,'Complete'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),==,'Hold'))))",
          "type": "genericGroup"
        },
        {
          "groupItems": [
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Approve",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "approveComplaint",
                      "pageFunction": {
                        "name": "approveComplaint",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer-complaint/{{__params.complaintId}}/approve",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      }
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),==,'Pending')",
                  "color": "green",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Sales | Manager),||,fn(MATCH_ROLE,General Manager))"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Hold",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "holdComplaint",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer-complaint/{{__params.complaintId}}/hold",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "holdComplaint"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),==,'Pending'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),==,'Open'))",
                  "color": "secondary",
                  "printable": false
                }
              ],
              "showIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Remove Hold",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "removeHold",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer-complaint/{{__params.complaintId}}/unHold",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "removeHold"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),==,'Hold')",
                  "color": "error",
                  "printable": false
                }
              ],
              "showIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Complete",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "completeComplaint",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer-complaint/{{__params.complaintId}}/mark-completed",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "completeComplaint"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),==,'Open')",
                  "color": "green",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,GENERAL_MANAGER))"
            },
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Reject",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openRejectionPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Reject Complaint"
                      },
                      "name": "openRejectionPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),==,'Rejected'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.complaint.data.status}},'),==,'Complete')))",
                  "color": "error",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))"
            }
          ],
          "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,PRODUCTION_MANAGER),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER)))",
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Reject Complaint",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.rejectionForm.reason",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Confirm",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectComplaint",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/customer-complaint/{{__params.complaintId}}/mark-rejected",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.rejectionForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "rejectComplaint"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeRejectionPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Reject Complaint"
                  },
                  "name": "closeRejectionPopup"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getComplaintDetail",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/customerComplaint/detail?id={{__params.complaintId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.complaint"
        },
        "name": "getComplaintDetail"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomerDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers/{{fetchedData.complaint.data.customer._id}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerDetails"
        },
        "name": "getCustomerDetails"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getInvoiceDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/invoice/{{fetchedData.complaint.data.invoice}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.invoiceDetails"
        },
        "name": "getInvoiceDetails"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "pushToInvoiceArray",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.invoiceDetails.data",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.invoicesArray"
        },
        "name": "pushToInvoiceArray"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "pushToCustomersArray",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customerDetails.data",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.customers"
        },
        "name": "pushToCustomersArray"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copyFormattedOrders",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getFormattedOrders",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyFormattedOrders",
        "executeIf": "fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}})"
      },
      {
        "executionOrder": 4,
          "pageFunction": {
          "name": "copyComplaintFormFields",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getComplaintFormFields",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyComplaintFormFields"
      },
      {
        "executionOrder": 5,
        "pageFunction": {
          "name": "copyDefectiveOrder",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.complaint.data.defectiveOrder",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.defectiveOrder"
        },
        "name": "copyDefectiveOrder",
        "executeIf": "{{fetchedData.complaint.data.defectiveOrder}}"
      },
      {
        "executionOrder": 5,
        "pageFunction": {
          "name": "copyDefectiveCalloff",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.complaint.data.defectiveCalloff",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.defectiveCalloff"
        },
        "name": "copyDefectiveCalloff",
        "executeIf": "{{fetchedData.complaint.data.defectiveCalloff}}"
      }
    ],
    "functions": [
      {
        "name": "getComplaintFormFields",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "complaintType": "{{fetchedData.complaint.data.complaintType}}",
          "customer": "{{fetchedData.complaint.data.customer._id}}",
          "invoice": "{{fetchedData.complaint.data.invoice}}",
          "defectiveQuantity": "{{fetchedData.complaint.data.defectiveQuantity}}",
          "description": "{{fetchedData.complaint.data.description}}",
          "pictures": "{{fetchedData.complaint.data.pictures}}",
          "investigation": "{{fetchedData.complaint.data.investigation}}",
          "managementDecision": "{{fetchedData.complaint.data.managementDecision}}",
        },
        "useFormula": true
      },
      {
        "name": "getFormattedOrders",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "invOrders": "fn(HELPER_FN,mergeInvoiceOrderFg,{{fetchedData.invoiceDetails.data}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER,QA_MANAGER,QA_TECHNICAL_EXECUTIVE,QA_QUALITY_EXECUTIVE,PRODUCTION_MANAGER,CUSTOMER_SERVICE_MANAGER",
  "visible": false
}